import { render, staticRenderFns } from "./CPageRow.vue?vue&type=template&id=be542c8e&scoped=true&"
import script from "./CPageRow.vue?vue&type=script&lang=ts&"
export * from "./CPageRow.vue?vue&type=script&lang=ts&"
import style0 from "./CPageRow.vue?vue&type=style&index=0&id=be542c8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be542c8e",
  null
  
)

export default component.exports